<nav class="breadcrumb-wrapper" aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li *ngFor="let breadcrumbItem of breadcrumbItems; let last = last;" class="breadcrumb-item" [class.active]="last"><a *ngIf="!last" [routerLink]="breadcrumbItem.routerLink">{{breadcrumbItem.label}}</a><span *ngIf="last">{{breadcrumbItem.label}}</span></li>
    </ol>
    <ul class="breadcrumb-extra">
        <ng-container *ngTemplateOutlet="linkTemplate"></ng-container>
        <li class="ml-auto"></li>
        <li *ngFor="let additionalTemplate of additionalTemplates" class="breadcrumb-additional-item"><ng-container *ngTemplateOutlet="additionalTemplate"></ng-container></li>
    </ul>
</nav>